// Add your custom JS here.
jQuery(document).ready(function($) {
  var lastScrollTop = 0;
  var ticking = false;
  

  $(window).scroll(function() {
	lastScrollTop = $(this).scrollTop();

	if (!ticking) {
	  window.requestAnimationFrame(function() {
		if (lastScrollTop > 140) {
		  $('.lcd-header').addClass("sticky");
		} else {
		  $('.lcd-header').removeClass("sticky");
		}
		ticking = false;
	  });

	  ticking = true;
	}
  });

//   $('.wpc-filter-title').on('click', function() {
//     const content = $(this).parent().next('.wpc-filter-content');
//     $(this).toggleClass('open');
//     content.toggleClass('open');
//   });

  

});



// HOME POST SLIDER
jQuery(document).ready(function($) {
	
	$('.card-slider').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.slider');
		var $next = $(sliderWrap).find('.next');
		var $prev = $(sliderWrap).find('.prev');
		$slider.slick({
			adaptiveHeight: false,
			slidesToShow: 4.5,
			slidesToScroll: 1,
			infinite: true,
			dots: false,
			nextArrow: $next,
			prevArrow: $prev,
			autoplay: true,
			autoplaySpeed: 3500,
			useAutoplayToggleButton: false,
			responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 3.5,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 2.5,
				slidesToScroll: 1
			  }
			},
			{
			  breakpoint: 600,
			  settings: {
				slidesToShow: 1.5,
				slidesToScroll: 1
			  }
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
			]
		});
	});
});



document.addEventListener('click', function(e){
  const a = e.target.closest('.pagination a, .page-numbers');
  if (!a) return;
  a.href = a.href.replace(/#.*$/,'') + '#journals-area';
}, {passive:true});